<template>
  <div>
    <div class="row">
      <div class="col-6">
        <b>Landing Page for:</b> {{ site.name }}
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form>
          <div v-for="phoenix_setting in filtered_phoenix_settings" :key="phoenix_setting.phoenix_setting_id">
            <div class="form-group row" v-if="phoenix_setting.setting === 'COMPONENT'">
              <label class="col-4 col-form-label">Component</label>
              <div class="col-6">
                <select class="form-control" v-model="phoenix_setting.value">
                  <option value="Calendar">Calendar</option>
                  <option value="Map">Map</option>
                </select>
              </div>
            </div>
            <div class="form-group row" v-if="phoenix_setting.setting === 'MAP_ID' && show_map_id">
              <label class="col-4 col-form-label">Map ID</label>
              <div class="col-6">
                <select class="form-control" id="ddlMaps" v-model="phoenix_setting.value">
                  <option value="0">Select..</option>
                  <option v-for="map in maps" :key="map.map_id" v-bind:value="String(map.map_id)">
                    {{ map.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()" v-if="[3].includes(logged_in_user.group_id)">Save</button>
          <router-link :to="{ name: 'AdminSiteIndex' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'site_id'
  ],
  computed: {
    ...mapGetters({
      maps: 'siteMaps',
      phoenix_settings: 'allPhoenixSettings',
      logged_in_user: 'loggedInUser',
      scoped_site_id: 'scopedSiteId',
      site: 'singleSite'
    }),
    filtered_maps: function () {
      return this.maps.filter(map => map.site_id === this.site_id)
    },
    filtered_phoenix_settings: function () {
      return this.phoenix_settings.filter(ps => ps.site_id === this.site_id)
    },
    show_map_id: function () {
      return this.phoenix_settings.find(ps => ps.site_id === this.scoped_site_id && ps.setting === 'COMPONENT').value === 'Map'
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getMaps')
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.LANDING_PAGE')
    this.$store.dispatch('getSite', this.site_id)
  },
  methods: {
    submit () {
      this.$store.dispatch('editPhoenixSettings', this.phoenix_settings)
    }
  }
}
</script>

<style scoped>

</style>
